import React from 'react'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider'
import { makeStyles } from '@material-ui/core/styles'

import { COLORS } from 'styles'

import { DataParking } from '../types'
import { CardDashboad } from '../components'

const useStyles = makeStyles({
  title: {
    color: COLORS.FONT,
  },
  divider: {
    backgroundColor: COLORS.BASE,
  },
})

interface PropsParking {
  data: DataParking
}

const Parking: React.FC<PropsParking> = ({ data }) => {
  const classes = useStyles()

  const avgMinutes = data.tickets > 0 ? parseFloat((data.minutes / data.tickets).toFixed(2)) : 0
  const avgMinutesPrevious =
    data.tickets_previous > 0
      ? parseFloat((data.minutes_previous / data.tickets_previous).toFixed(2))
      : 0

  return (
    <>
      <Grid item xs={12}>
        <Typography variant="h6" component="h2" className={classes.title}>
          Parking
        </Typography>
        <Divider className={classes.divider} />
      </Grid>

      <Grid item xs={12} sm={4}>
        <CardDashboad
          value={data.payments}
          description="Pagos Realizados"
          value_previous={data.payments_previous}
          isPercent={false}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <CardDashboad
          value={data.total_amount}
          description="Total Pagos (UYU)"
          value_previous={data.total_amount_previous}
          isPercent={false}
          isCurrency
        />
      </Grid>

      <Grid item xs={12} sm={4}>
        <CardDashboad
          value={data.tickets}
          description="Tickets Emitidos"
          value_previous={data.tickets_previous}
          isPercent={false}
        />
      </Grid>

      <Grid item xs={12} sm={4}>
        <CardDashboad
          value={data.minutes}
          description="Minutos Totales"
          value_previous={data.minutes_previous}
          isPercent={false}
        />
      </Grid>

      <Grid item xs={12} sm={4}>
        <CardDashboad
          value={avgMinutes}
          description="Promedio Minutos/Ticket"
          value_previous={avgMinutesPrevious}
          isPercent={false}
        />
      </Grid>
    </>
  )
}

export { Parking }
